import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/v2/store/selectors/dashboard';

export const categoriesSelector = createSelector(dashboardSelector, (state) => state.categories);
